<div class="grid currently-excluded">
  <div class="academicayear">
    @if (daysThisTerm > 15) {
      <div class="float-right">
        <span><i class="pi pi-exclamation-circle exclamation-style"></i></span>
      </div>
    }
    <h2>{{ daysThisTerm }}</h2>
    <label>Days this term</label>
  </div>
  <div class="currently-excluded">
    <div class="academicayear">
      @if (daysThisAcademicYear > 15) {
        <div class="float-right">
          <span
            ><i class="pi pi-exclamation-circle exclamation-style"></i
          ></span>
        </div>
      }
      <h2>{{ daysThisAcademicYear }}</h2>
      <label>Days this academic year</label>
    </div>
  </div>
</div>
